import { createRouter, createWebHistory } from 'vue-router'
import { ElMessage } from 'element-plus'
import i18n from '@/locales'

const routes = [
  {
    path: '/',
    name: 'LandingPage',
    component: () => import('@/views/Landing.vue'),
    meta: {
      title: '元译科技',
      description: '专注翻译技术的智能平台',
      navbar: 'cyber',
      layout: 'cyber'
    }
  },
  {
    path: '/practice',
    name: 'PracticePage',
    component: () => import('@/views/PracticePage.vue'),
    meta: {
      title: '实务练习',
      description: 'CATTI翻译实务练习平台'
    },
    // CATTI 实务系统暂未开放：导航入口已置灰，这里再拦一层，防止直接输 URL 进来。
    // 解冻时删掉这个 beforeEnter 即可（页面组件本身没动）。
    beforeEnter: () => {
      ElMessage.info(i18n.global.t('nav.featureNotOpen'))
      return { path: '/' }
    }
  },
  {
    path: '/translation-tool',
    name: 'TranslationTool',
    component: () => import('@/views/tools/TranslationTool.vue'),
    meta: {
      title: '超强翻译工具',
      description: 'AI驱动的智能翻译解决方案',
      navbar: 'cyber',
      layout: 'cyber'
    }
  },
  {
    path: '/translation-services',
    name: 'TranslationServices',
    component: () => import('@/views/TranslationServices.vue'),
    meta: {
      title: '笔译服务',
      description: '机器翻译、AI润色与人工审校一站式笔译服务',
      navbar: 'cyber',
      layout: 'cyber'
    }
  },
  {
    path: '/api-tutorial',
    name: 'ApiTutorial',
    component: () => import('@/views/ApiTutorial.vue'),
    meta: {
      title: 'API教程',
      description: '各大AI平台API获取教程',
      navbar: 'cyber',
      layout: 'cyber'
    }
  },
  {
    path: '/terminology-tool',
    name: 'TerminologyTool',
    component: () => import('@/views/tools/TerminologyTool.vue'),
    meta: {
      title: '术语库创建工具',
      description: '专业术语库创建和管理工具',
      navbar: 'cyber',
      layout: 'cyber'
    }
  },
  {
    path: '/word-count-tool',
    name: 'WordCountTool',
    component: () => import('@/views/tools/WordCountTool.vue'),
    meta: {
      title: '字数统计工具',
      description: '精准高效的文档字数统计工具',
      navbar: 'cyber',
      layout: 'cyber'
    }
  },
  {
    path: '/word-frequency-tool',
    name: 'WordFrequencyTool',
    component: () => import('@/views/tools/WordFrequencyTool.vue'),
    meta: {
      title: '词频统计工具',
      description: '快速统计文档词频的专业工具',
      navbar: 'cyber',
      layout: 'cyber'
    }
  },
  {
    path: '/corpus-alignment-tool',
    name: 'CorpusAlignmentTool',
    component: () => import('@/views/tools/CorpusAlignmentTool.vue'),
    meta: {
      title: '语料对齐工具',
      description: '智能双语平行语料对齐工具',
      navbar: 'cyber',
      layout: 'cyber'
    }
  },
  {
    path: '/comprehensive-test',
    name: 'ComprehensiveTest',
    component: () => import('@/views/ComprehensiveTest.vue'),
    meta: {
      title: 'CATTI综合考试',
      description: 'CATTI考试练习系统'
    }
  },
  {
    path: '/exam-history',
    name: 'ExamHistory',
    component: () => import('@/views/ExamHistoryView.vue'),
    meta: {
      title: '答题历史',
      description: 'CATTI考试答题历史记录'
    }
  },
  {
    path: '/wrong-questions',
    name: 'WrongQuestions',
    component: () => import('@/views/WrongQuestionsView.vue'),
    meta: {
      title: '错题本',
      description: 'CATTI考试错题复习'
    }
  },
  // 管理员登录页面
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('@/views/admin/AdminLogin.vue'),
    meta: {
      title: '管理员登录',
      description: '元译科技后台管理系统登录'
    }
  },
  // 管理后台主路由
  {
    path: '/admin',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'AdminDashboard',
        component: () => import('@/views/admin/AdminDashboard.vue'),
        meta: {
          title: '管理后台首页',
          requiresAuth: true
        }
      },
      {
        path: 'countdown',
        name: 'AdminCountdown',
        component: () => import('@/components/admin/CountdownConfig.vue'),
        meta: {
          title: '倒计时配置',
          requiresAuth: true
        }
      },
      {
        path: 'api-config',
        name: 'AdminApiConfig',
        component: () => import('@/views/admin/ApiConfigPage.vue'),
        meta: {
          title: 'API配置',
          requiresAuth: true
        }
      },
      {
        path: 'access-codes',
        name: 'AdminAccessCodes',
        component: () => import('@/views/admin/AccessCodesPage.vue'),
        meta: {
          title: '激活码管理',
          requiresAuth: true
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  try {
    console.log('路由守卫触发:', { to: to.path, from: from.path })

    // 检查管理员登录状态
    const adminToken = localStorage.getItem('adminToken')
    const isAdmin = !!adminToken

    console.log('当前用户状态:', isAdmin ? '管理员' : '普通用户')

    // 如果访问管理后台但未登录，重定向到登录页
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!isAdmin) {
        console.log('需要管理员权限但用户未登录，重定向到登录页')
        next({
          path: '/admin/login',
          query: { redirect: to.fullPath } // 保存目标路径，登录后可以跳转回来
        })
      } else {
        console.log('管理员已登录，允许访问')
        next()
      }
    }
    // 如果已登录但访问登录页，重定向到管理后台首页
    else if (to.path === '/admin/login' && isAdmin) {
      console.log('已登录用户访问登录页，重定向到管理后台首页')
      next({ path: '/admin' })
    }
    else {
      console.log('无特殊要求的页面，允许访问')
      next()
    }
  } catch (error) {
    console.error('路由守卫出错:', error)
    next()
  }
})

// 懒加载的页面 chunk 拉不下来时，导航会静默失败、页面停在上一个状态，
// 从界面上看就是"打不开也没报错"。这里至少把原因打到控制台。
router.onError((error) => {
  console.error('路由加载失败:', error)
})

export default router 
